import { IconButton } from "@volvo/vcdk-react/IconButton";
import { Typography } from "@volvo/vcdk-react/Typography";
import { Link } from "@volvo/vcdk-react/Link";
import { HeaderExpressive } from "@volvo/vcdk-react/HeaderExpressive";
import TopSearchTextField from "./TopSeachBar/TopSearchTextBox"

const TopNavigation = ({
    toggle,
    onSideNavToggleClick,
    userInfo,
    selectedRegion,
    openSettingsDialog,
}: {
    toggle: boolean
    onSideNavToggleClick: any
    userInfo: any
    selectedRegion: any
    openSettingsDialog: any
}) => {
   const iconStyle = {
        width: "44px",
    }
    const regionStyle = {
        transition: "padding-left .3s",
        display: "flow-root",
        fontSize: "16px",
    }
    const barStyle = {
        "--vcdk-bar-height": "60px",
    } as React.CSSProperties
    return (
       <>
        <div style={{top: 0, position: "absolute", zIndex: 3, left: 0, width: "100%"}}>
            <HeaderExpressive style={barStyle}>
                <Link size="small" href="/" slot="bar-start">
                    <img alt="" src="/volvo-logo.png" style={iconStyle}></img>
                </Link>
                <div  slot="bar-start" style={{...regionStyle,marginLeft: "10px"}}>
                    <p className="mb-0 font-weight-bold text-muted" style={{fontSize: "1rem", lineHeight: 1}}>
                         {process.env.REACT_APP_GATEWAY_API_URL && process.env.REACT_APP_GATEWAY_API_URL.includes("https://mot-api-qa.volvotrucks.co.uk/api/") && <b style={{color: "red",fontSize: "28px"}}>QA</b>}
                            Volvo Trucks
                    </p>
                    <p
                        className="mb-0"
                        style={{
                            fontSize: "0.75rem",
                            fontWeight: "400",
                            letterSpacing: "-.1px",
                            lineHeight: "1.5",
                            textTransform: "uppercase",
                        }}
                    >
                        UNITED KINGDOM & IRELAND
                    </p>
                </div>
                <div slot="bar-center" >
                    <TopSearchTextField />
                </div>
                <div slot="bar-end" style={{...regionStyle, textAlign: "right",marginRight: "10px"}}>
                    <p
                        className="mb-0 font-weight-bold text-muted"
                        style={{
                            fontSize: "0.75rem",
                            letterSpacing: "-.1px",
                            lineHeight: "1.5",
                            textTransform: "uppercase",
                            fontWeight: "bold",
                        }}
                    >
                        {selectedRegion.regionName}
                    </p>
                    <p className="mb-0" style={{fontSize: "12px"}}>
                        {userInfo && userInfo.username}
                    </p>
                </div>
                <IconButton slot="bar-end" size="small" icon="user" filled={true} onClick={() => {
                       openSettingsDialog(true)
                }} />
            </HeaderExpressive>
        </div>
            <div style={{position: "absolute", top: "60px", zIndex:3, backgroundColor: "#e1dfdd", width: "100%", padding: ".5rem",alignItems: "center",justifyContent: "start", display: "flex"}}>
                <IconButton size="small" icon={toggle ? "close" : "hamburger-menu"} onClick={() => {
                        onSideNavToggleClick()
                }}/>
                <Typography variant="body" style={{marginLeft:"10px"}}>Annual Inspections</Typography>
            </div>
        </>
    )
}

export default TopNavigation
